import React from 'react';
import { css } from '@emotion/core';
import moment from 'moment';
import { formatCentsToCurrency } from '../../../helpers/currency';
import { theme } from '@weave/theme-original';
import { Text } from '@weave/design-system';

type CurrentPricingProps = {
  title: string;
  processingRate: number;
  processingRateSubText?: string | React.ReactNode;
  transactionCost: number;
  transactionCostSubText?: string | React.ReactNode;
  date: string;
};

export const CurrentPricing = (props: CurrentPricingProps) => {
  return (
    <div
      css={css`
        div:nth-child(3) {
          background-color: #f5f5f5;
        }
        border-radius: ${theme.borderRadius.medium};
        overflow: hidden;
        box-shadow: ${theme.shadows.heavy};
      `}
    >
      <Text
        css={css`
          background-color: ${theme.colors.weaveBlue};
          margin: 0px;
          padding: 10px;
          color: white;
        `}
        weight="bold"
        textAlign="center"
      >
        {props.title}
      </Text>
      <PricingRow
        label="Processing Rate"
        value={`${props.processingRate / 100}%`}
        subtext={props?.processingRateSubText}
      />
      <PricingRow
        label="Transaction Cost"
        value={`${formatCentsToCurrency(props.transactionCost)}`}
        subtext={props?.transactionCostSubText}
      />
      <PricingRow label="Date" value={moment(props.date).format('MMM D, YYYY')} />
    </div>
  );
};

type PricingRowProps = {
  label: string;
  value: string;
  subtext?: string | React.ReactNode;
};

const PricingRow = ({ label, value, subtext }: PricingRowProps) => (
  <div
    css={css`
      display: flex;
      padding: 15px;
      width: 300px;
      align-items: center;
    `}
  >
    <div>
      <Text
        css={css`
          margin-bottom: 0px;
        `}
        size="medium"
        weight="semibold"
      >
        <strong>{label}</strong>
      </Text>
      {subtext &&
        (typeof subtext === 'string' ? (
          <Text
            size="medium"
            css={css`
              margin-bottom: 0px;
            `}
          >
            {subtext}
          </Text>
        ) : (
          subtext
        ))}
    </div>
    <Text
      weight="medium"
      css={css`
        margin-bottom: 0px;
        margin-left: auto;
        color: ${label === 'Date' ? theme.colors.gray500 : theme.colors.gray600};
      `}
    >
      {value}
    </Text>
  </div>
);
